import React from 'react';
import { Row } from 'antd';
import { FormField, maxLength, alphaNumeric } from 'common';

const warnBlock = [maxLength(5)];
const warnLot = (value: string) =>
  value &&
  !/^[0-9]{1,4}(-[0-9]{1,4})?(, ?[0-9]{1,4}(-[0-9]{1,4})?)*$/.test(value)
    ? 'Invalid lot value'
    : undefined;
const warnEasement = [maxLength(4), alphaNumeric];

const BlockLotFormFields: React.FC<{
  handleFieldFocus: any;
  tabNamePrefix: string;
  rowStyle: string;
  inputStyle: string;
  autoFocusFirstField?: boolean;
  startingTabIndex?: number;
}> = ({
  handleFieldFocus,
  tabNamePrefix,
  rowStyle,
  inputStyle,
  autoFocusFirstField = true,
  startingTabIndex = 0,
}) => {
  let tabIndex = startingTabIndex;
  const getNextTabIndex = (): number => {
    if (tabIndex === 0) return tabIndex;
    return (tabIndex += 100);
  };

  return (
    <>
      <Row type="flex" align="middle" className={rowStyle}>
        <FormField
          tabIndex={startingTabIndex}
          onFocus={handleFieldFocus}
          warn={warnBlock}
          label="Block"
          name={`${tabNamePrefix}.block`}
          autoFocus={autoFocusFirstField}
          className={inputStyle}
        />
        <FormField
          tabIndex={getNextTabIndex()}
          onFocus={handleFieldFocus}
          warn={warnLot}
          label="Lot(s)"
          tooltip="Allows numbers, commas, and dashes for multiple lots. ex: '1, 3, 5-7'"
          name={`${tabNamePrefix}.lot`}
          className={inputStyle}
        />
        <FormField
          tabIndex={getNextTabIndex()}
          onFocus={handleFieldFocus}
          warn={warnEasement}
          label="Easement"
          name={`${tabNamePrefix}.ease`}
        />
      </Row>
    </>
  );
};

export default React.memo(BlockLotFormFields);
